import {
  defaultOrderFn,
  prepareTableData,
  getServiceSortIndex,
  createNumericOrderFn,
  orderExceptions,
} from '../features/routeDetail/model';
import { formatDisplayNumberToFloat } from './stop';

import { COLUMN_ACCESSORS as CA } from '../constants/table';

const RAG_ORDER = {
  R: 1,
  A: 2,
  G: 3,
};

const getRagOrder = ({ ragStatus }) => RAG_ORDER[ragStatus] || 0;

const getNCLength = ({ nonCompatibles }) => (nonCompatibles || '').length;

const getManifestLocationValue = ({ manifestLocation }) =>
  (manifestLocation || []).join('');

export const getSortFn = (accessor, isAscending) => {
  const asc = isAscending ? 1 : -1;
  switch (accessor) {
    case CA.DISPLAY_NUMBER:
      return (a, b) =>
        asc *
        defaultOrderFn(
          formatDisplayNumberToFloat(a),
          formatDisplayNumberToFloat(b),
          'displayNumber'
        );
    case CA.SERVICE:
      return (a, b) => asc * (getServiceSortIndex(a) - getServiceSortIndex(b));
    case CA.RAG:
      return (a, b) => {
        const orderA = getRagOrder(a);
        const orderB = getRagOrder(b);
        if (orderA > orderB) {
          return asc;
        } else if (orderA < orderB) {
          return -asc;
        }

        return 0;
      };
    case CA.OT:
      return (a, b) => asc * createNumericOrderFn('opportunityTime')(a, b);
    case CA.EXCEPTION:
      return (a, b) => asc * orderExceptions(a, b);
    case CA.NC:
      return (a, b) => asc * (getNCLength(b) - getNCLength(a));
    case CA.WEIGHT:
      return (a, b) => asc * createNumericOrderFn('weight')(a, b);
    case CA.REQUESTS:
      return (a, b) => asc * (b.requests?.length - a.requests?.length);
    case CA.MANIFEST_LOCATION:
      return (a, b) =>
        asc *
        getManifestLocationValue(a).localeCompare(getManifestLocationValue(b));
    default:
      return (a, b) => asc * defaultOrderFn(a, b, accessor);
  }
};

export const getSortedStops = (stops, { accessor, isAscending }) =>
  prepareTableData(stops).sort(getSortFn(accessor, isAscending));
